import React from 'react';
import { withRouter } from 'react-router-dom';
import {Form,Input,Tree,Button,Spin} from 'antd';
import abortAjaxHoc from 'components/abortAjaxHoc';

const FormItem = Form.Item;
const TreeNode = Tree.TreeNode;


class RoleMemberEdit extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            loading:true,
            permissionList:[],
            selected:[],
            canSubmit:this.props.match.params.id?true:false,
            isUserPerLoading:false
        };
        this.mod = null;
        this.id = this.props.match.params.id;
    }

    componentDidMount(){
        if(this.id){
            console.log(123);
            //'/roles/'+id
            this.props.abortableAjax('GET','/roles/'+this.id).then(res=>{
                this.props.form.setFieldsValue({
                    name:res.data.name,
                    desc:res.data.desc
                });
            });
            //'/auth/role/'+id+'/permissions'
            this.props.abortableAjax('GET','/auth/role/'+this.id+'/permissions').then(res => {
                const data = res.data;
                const selectPath = data.map(item => {
                    return item.permission_id + '';
                });
                this.setState({selected: selectPath, isUserPerLoading: false});
            });
        };
        this.props.abortableAjax('GET','/auth/permissions').then(res=>{
            this.setState({permissionList:res.data,loading:false});
        });
    }

    onCheck(checkedKeys){
        this.setState({selected:checkedKeys});
    }
    onAdd(){
        this.props.form.validateFields((error,values)=>{
            if(!error){
                const params = {...values};
                params['selected-permissions'] = this.state.selected.join(',');
                let url = '/roles';
                let method = 'PUT';
                const id = this.props.match.params.id;
                if(id){
                    url = url + '/' + id;
                    method = 'POST';
                }
                this.setState({canSubmit:false});
                this.props.abortableAjax(method,url,params).then(res=>{
                    this.props.history.push('/pages/role-management');
                }).catch(()=>{
                    this.setState({canSubmit:true});
                });
            }

        });

    }
    onNameChange(){
        setTimeout(()=>{
            this.props.form.validateFields((error)=>{
                if(!error){
                    this.setState({canSubmit:true});
                }else{
                    this.setState({canSubmit:false});
                }
            });
        }, 100);
    }

    loop(data){
        const res = [];
        for(const item in data){

            const one = data[item];
            const info = one.data;
            const title = <a className='tree-title'>{info.display_name}<span>&nbsp;{info.desc?'('+info.desc+')':null}</span></a>;
            if(one.children){
                res.push(<TreeNode key={info.id+''} title={title}>
                    {this.loop(one.children)}
                </TreeNode>);
            }else{
                res.push(<TreeNode key={info.id+''} title={title} />);
            }
        }
        return res;
    }

    render(){
        const {permissionList,loading} = this.state;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 }
            },
            wrapperCol: {
                xs: { span: 6 },
                sm: { span: 6 }
            }
        };
        //转换数组
        const res = {};
        permissionList.map(item=>{
            const pathArray = item.tree_path.split('-');
            let temp = res;
            let i = 0;
            while(i<pathArray.length){

                if(i==pathArray.length-1){

                    if(!temp[pathArray[i]]){
                        temp[pathArray[i]] = {data:item};
                    }else{
                        temp[pathArray[i]].data = item;
                    }
                }else{
                    if(!temp[pathArray[i]]){
                        temp[pathArray[i]] = {children:{}};
                    }else{
                        if(!temp[pathArray[i]].children){
                            temp[pathArray[i]].children = {};
                        }
                    }
                    temp = temp[pathArray[i]].children;
                }
                i++;
            }
        });

        const treeNode = this.loop(res);
        let tree = <Spin tip="Loading..."/>;
        if (permissionList.length != 0 && !this.state.isUserPerLoading){
            tree = <div>
                <Tree
                    checkable
                    defaultExpandAll
                    autoExpandParent={true}
                    checkedKeys = {this.state.selected}
                    onCheck={this.onCheck.bind(this)}
                >
                    {treeNode}
                </Tree>
                <Button disabled={!this.state.canSubmit} style={{'marginBottom':'20px'}} type="primary" onClick={this.onAdd.bind(this)}>Confirm</Button>
            </div>;
        }

        return <div>
            <Spin spinning={loading}>
                <Form layout='vertical' onSubmit={this.handleSubmit} style={{'margin':'20px 0'}}>
                    <FormItem
                        {...formItemLayout}
                        label="Role Name"
                    >
                        {getFieldDecorator('name',{
                            rules: [
                                { required: true, message: 'Please enter role name' },
                                { max:32,message: 'Role name cannot exceed 32 characters'}
                            ]
                        })(
                            <Input onChange={this.onNameChange.bind(this)} placeholder="Role name cannot exceed 32 characters"/>
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Description"
                    >
                        {getFieldDecorator('desc',{
                            rules: [
                                { max:640,message: 'Role description cannot exceed 640 characters'}
                            ]
                        })(
                            <Input placeholder="Role description cannot exceed 640 characters"/>
                        )}
                    </FormItem>
                </Form>
            </Spin>
            {tree}

        </div>;
    }
}
const RoleMemberEditForm = Form.create()(RoleMemberEdit);
export default abortAjaxHoc(withRouter(RoleMemberEditForm));



// WEBPACK FOOTER //
// ./src/pages/roleManagenment/RoleMemberEdit.js